import { useState } from 'react';
import { Loader2, RefreshCw } from 'lucide-react';
import { useAnalysisRun } from '../../shared/api/useAnalysisRun.js';
import './refresh-analysis.css';

/**
 * Runs the analysis chain on demand, next to the freshness stamp it refreshes.
 *
 * The engine loops hourly, so a gesture made on the site can take up to an hour
 * to reach the Console. In development one runs `npm run engine:once`; a team
 * conducting its own acceptance has no terminal, and would read an empty screen
 * without knowing why.
 */
export function RefreshAnalysis({ projectId }: { projectId: string | undefined }) {
  const run = useAnalysisRun(projectId);
  const [error, setError] = useState<string | null>(null);

  if (!projectId) return null;

  const trigger = () => {
    setError(null);
    run.mutate(undefined, {
      onError: (cause) =>
        setError(cause instanceof Error ? cause.message : "L'analyse n'a pas pu être lancée"),
    });
  };

  return (
    <span className="refresh-analysis">
      <button
        type="button"
        className="refresh-analysis__btn"
        onClick={trigger}
        disabled={run.isPending}
        title="Recalcule les indicateurs à partir des événements déjà collectés. Le moteur passe sinon une fois par heure."
      >
        {run.isPending ? <Loader2 size={14} className="refresh-analysis__spin" /> : <RefreshCw size={14} />}
        {run.isPending ? 'Analyse en cours…' : 'Actualiser l’analyse'}
      </button>
      {error && (
        <span className="refresh-analysis__error" role="alert">
          {error}
        </span>
      )}
    </span>
  );
}
